module.exports = __webpack_public_path__ + "media/images/application/template/products/homepage_site_accommodation_mob-0cbfab2088f598ac6726fc6df8692bcb.png";